import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { api_url, environment } from "../config.js";

const fake_token =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOi9hay5leGFtcGxlLmNvbS9hdXRoL3JlYWxttV7Y3cskztDZqqmQI";

export const getFlavors = createAsyncThunk(
  "flavor/getFlavors",
  async (_, { getState, rejectWithValue }) => {
    const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");
    const token =
      environment === "production-no-auth" ? fake_token : keycloak?.token;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get(`${api_url}/flavors`, config);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || "An unexpected error occurred.",
      );
    }
  },
);

export const getFlavorInfo = createAsyncThunk(
  "flavor/getFlavorInfo",
  async (name, { getState, rejectWithValue }) => {
    const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");

    const token =
      environment === "production-no-auth" ? fake_token : keycloak?.token;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get(`${api_url}/flavors/${name}`, config);
      return data;
    } catch (error) {
      if (environment === "development") {
        console.error("Error :", error.message);
      }
      return rejectWithValue(
        error.response?.data?.detail || "An unexpected error occurred.",
      );
    }
  },
);

export const getFlavorInfoByName = createAsyncThunk(
  "flavor/getFlavorInfoByName",
  async (name, { rejectWithValue }) => {
    const keycloak = JSON.parse(localStorage.getItem("keycloak") || "{}");

    const token =
      environment === "production-no-auth" ? fake_token : keycloak?.token;

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      const { data } = await axios.get(`${api_url}/flavors`, config);

      const normalized = name?.trim().toLowerCase();

      const flavor = data.find(
        (f) => (f.name || "").trim().toLowerCase() === normalized,
      );

      if (!flavor) {
        return rejectWithValue(`Flavor with name "${name}" not found.`);
      }

      return flavor;
    } catch (error) {
      if (environment === "development") {
        console.error("Error :", error.message);
      }
      return rejectWithValue(
        error.response?.data?.detail || "An unexpected error occurred.",
      );
    }
  },
);
